import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=2d525bdc&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=2d525bdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d525bdc",
  null
  
)

export default component.exports